let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dqho9")).then(() => parcelRequire('kc1MS'));